<mat-sidenav-container class="mobile-sidenav-container">
  <mat-sidenav
    #mobileSidenav
    class="mobile-sidenav"
    mode="over"
    [opened]="isSidenavOpen"
    (closedStart)="closeSidenav()"
  >
    <mat-toolbar class="mobile-sidenav__header">
      <span>Punto de Venta</span>
      <button mat-icon-button (click)="closeSidenav()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/main/inicio" routerLinkActive="active" (click)="closeSidenav()">
        <mat-icon class="menu-icon">home</mat-icon>
        <span class="menu-text">Inicio</span>
      </a>
      <a mat-list-item routerLink="/main/productos" routerLinkActive="active" (click)="closeSidenav()">
        <mat-icon class="menu-icon">inventory_2</mat-icon>
        <span class="menu-text">Productos</span>
      </a>
      <a mat-list-item routerLink="/main/ventas" routerLinkActive="active" (click)="closeSidenav()">
        <mat-icon class="menu-icon">point_of_sale</mat-icon>
        <span class="menu-text">Ventas</span>
      </a>
      <ng-container *ngIf="!isVendedor">
        <a mat-list-item routerLink="/main/proveedores" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">people</mat-icon>
          <span class="menu-text">Proveedores</span>
        </a>
        <a mat-list-item routerLink="/main/reportes" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">bar_chart</mat-icon>
          <span class="menu-text">Reportes</span>
        </a>
        <a mat-list-item routerLink="/main/reportes-proveedor" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">trending_up</mat-icon>
          <span class="menu-text">Rpt. Proveedores</span>
        </a>
        <a mat-list-item routerLink="/main/cortes" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">receipt_long</mat-icon>
          <span class="menu-text">Cortes</span>
        </a>
        <a mat-list-item routerLink="/main/cortes-proveedor" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">receipt_long</mat-icon>
          <span class="menu-text">Cortes por Proveedor</span>
        </a>
        <a mat-list-item routerLink="/main/produccion" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">precision_manufacturing</mat-icon>
          <span class="menu-text">Producción</span>
        </a>
        <a mat-list-item routerLink="/main/corte-caja" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">point_of_sale</mat-icon>
          <span class="menu-text">Corte de Caja</span>
        </a>
        <a mat-list-item routerLink="/main/historial-inventario" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">history</mat-icon>
          <span class="menu-text">Historial Inventario</span>
        </a>
        <a mat-list-item routerLink="/main/configuracion" routerLinkActive="active" (click)="closeSidenav()">
          <mat-icon class="menu-icon">settings</mat-icon>
          <span class="menu-text">Configuración</span>
        </a>
      </ng-container>
      <a mat-list-item (click)="logout()">
        <mat-icon class="menu-icon">exit_to_app</mat-icon>
        <span class="menu-text">Cerrar Sesión</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="mobile-content" [class.has-overlay]="isSidenavOpen">
    <mat-toolbar class="mobile-header">
      <button mat-icon-button (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="header-title">Punto de Venta</span>
      <span class="spacer"></span>
      <app-low-stock-notification></app-low-stock-notification>
      <button mat-icon-button (click)="openSearchDialog()">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button (click)="openDialog()">
        <mat-icon class="btn-icon">add</mat-icon>
      </button>
      <button mat-icon-button>
        <mat-icon>account_circle</mat-icon>
      </button>
    </mat-toolbar>

    <div class="mobile-content-wrapper" (click)="closeSidenav()">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

